import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "center-wrapper" }
const _hoisted_2 = { class: "input-block" }
const _hoisted_3 = { class: "input-block" }
const _hoisted_4 = { class: "input-block" }
const _hoisted_5 = {
  key: 0,
  class: "invalid-text",
  style: {"text-align":"right","padding":"4px"}
}
const _hoisted_6 = { class: "input-block" }
const _hoisted_7 = { class: "input-block" }
const _hoisted_8 = { class: "input-block" }
const _hoisted_9 = { class: "input-block" }
const _hoisted_10 = { class: "input-block" }
const _hoisted_11 = { class: "input-block" }
const _hoisted_12 = {
  key: 0,
  class: "invalid-text",
  style: {"text-align":"center","padding":"2px"}
}
const _hoisted_13 = { class: "input-block" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "input-block" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "input-block" }
const _hoisted_18 = { class: "input-block" }
const _hoisted_19 = { style: {"text-align":"center","padding-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JapaneseInput = _resolveComponent("JapaneseInput")!
  const _component_select_prefecture = _resolveComponent("select-prefecture")!
  const _component_select_store = _resolveComponent("select-store")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block-label" }, "顧客名", -1)),
        _createVNode(_component_JapaneseInput, {
          modelValue: _ctx.editCustomer.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editCustomer.name) = $event)),
          id: "focusOnEdit",
          onKeyup: _ctx.keyUp,
          onKeydown: _ctx.keyDown,
          onClick: _ctx.onNameClick,
          onBlur: _ctx.writeKana
        }, null, 8, ["modelValue", "onKeyup", "onKeydown", "onClick", "onBlur"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block-label" }, "顧客名カナ", -1)),
        _createVNode(_component_JapaneseInput, {
          modelValue: _ctx.editCustomer.kana,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editCustomer.kana) = $event)),
          onBlur: _ctx.hiraToKana
        }, null, 8, ["modelValue", "onBlur"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block-label" }, "郵便番号", -1)),
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["form-control", _ctx.zipNotFound ? 'is-invalid' : '']),
          type: "tel",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editCustomer.zipCode) = $event)),
          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.writeZip && _ctx.writeZip(...args)))
        }, null, 34), [
          [_vModelText, _ctx.editCustomer.zipCode]
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("div", { style: {"font-size":"9px","text-align":"right","padding":"4px"} }, "※半角ハイフンを入れて入力してください", -1)),
        (_ctx.zipNotFound)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "郵便番号に対応する住所が見つかりませんでした"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block-label" }, "都道府県", -1)),
        _createVNode(_component_select_prefecture, {
          prefecture: _ctx.editCustomer.prefecture,
          "onUpdate:prefecture": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editCustomer.prefecture) = $event))
        }, null, 8, ["prefecture"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block-label" }, "市区町村", -1)),
        _createVNode(_component_JapaneseInput, {
          modelValue: _ctx.editCustomer.city,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editCustomer.city) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block-label" }, "地区番地", -1)),
        _createVNode(_component_JapaneseInput, {
          modelValue: _ctx.editCustomer.street,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editCustomer.street) = $event))
        }, null, 8, ["modelValue"]),
        _cache[21] || (_cache[21] = _createElementVNode("div", { style: {"font-size":"9px","text-align":"right","padding":"4px"} }, "※全角スペース（空白）は使用しないでください", -1))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block-label" }, "建物内住所", -1)),
        _createVNode(_component_JapaneseInput, {
          modelValue: _ctx.editCustomer.building,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editCustomer.building) = $event))
        }, null, 8, ["modelValue"]),
        _cache[23] || (_cache[23] = _createElementVNode("div", { style: {"font-size":"9px","text-align":"right","padding":"4px"} }, "※全角スペース（空白）は使用しないでください", -1))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block-label" }, "電話番号", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control no-ime",
          type: "tel",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editCustomer.phoneNo) = $event)),
          onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toHankakuPhone && _ctx.toHankakuPhone(...args)))
        }, null, 544), [
          [_vModelText, _ctx.editCustomer.phoneNo]
        ]),
        _cache[25] || (_cache[25] = _createElementVNode("div", { style: {"font-size":"9px","text-align":"right","padding":"4px"} }, "※半角ハイフンを入れて入力してください", -1))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block-label" }, "前回印刷日", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "datetime-local",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editCustomer.printDate) = $event))
        }, null, 512), [
          [_vModelText, _ctx.editCustomer.printDate]
        ]),
        (!_ctx.$root.util.isValidDate(_ctx.editCustomer.printDate))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, "有効な日付ではありません"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block-label" }, "登録日", -1)),
        _createElementVNode("input", {
          class: "form-control",
          type: "tel",
          value: _ctx.$root.util.formatDateTime(_ctx.editCustomer.created_at),
          tabindex: "-1",
          readonly: ""
        }, null, 8, _hoisted_14)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[28] || (_cache[28] = _createElementVNode("label", { class: "block-label" }, "更新日", -1)),
        _createElementVNode("input", {
          class: "form-control",
          type: "tel",
          value: _ctx.$root.util.formatDateTime(_ctx.editCustomer.updated_at),
          tabindex: "-1",
          readonly: ""
        }, null, 8, _hoisted_16)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _cache[29] || (_cache[29] = _createElementVNode("label", { class: "block-label" }, "担当店", -1)),
        _createVNode(_component_select_store, {
          store: _ctx.editCustomer.store,
          "onUpdate:store": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editCustomer.store) = $event))
        }, null, 8, ["store"])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block-label" }, "備考", -1)),
        _withDirectives(_createElementVNode("textarea", {
          class: "form-control",
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editCustomer.note) = $event)),
          rows: "5"
        }, null, 512), [
          [_vModelText, _ctx.editCustomer.note]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("button", {
        class: "btn-primary",
        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
      }, "保存")
    ])
  ], 64))
}